import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { Client } from 'src/app/model/client';
import { AssignNursePractitioner, NursePractitioner} from 'src/app/model/np-data';
import { Project } from 'src/app/model/project';
import { Scheduler, SchedulerData } from 'src/app/model/schedulers-data';
import { ClientService } from 'src/app/service/client.service';
import { NotificationService } from 'src/app/service/notification.service';
import { NursePractitionerService } from 'src/app/service/nursepractitioner.service';
import { ProjectService } from 'src/app/service/project.service';
import { SchedulerService } from 'src/app/service/scheduler.service';


@Component({
  selector: 'app-assignnp-modal',
  templateUrl: './assignnp-modal.component.html',
  styleUrls: ['./assignnp-modal.component.scss']
})
export class AssignnpModalComponent implements OnInit {

  _assignForm: FormGroup;
  assignNursePractitionerRequest: AssignNursePractitioner = new AssignNursePractitioner();
  clients: Client[];
  selectedClient: string[]=[];
  projects: Project[]=[];
  project: Project;
  selectedProject: string[]=[];
  newNP: NursePractitioner[];
  assignedNps: NursePractitioner[];
  //assignNursePractitioners: AssignNursePractitioners[]=[];
  //nursePractitioners: AssignNursePractitioner[]=[];

  selectedProjects: Project[] = [];

  isAssigned: boolean = false;
  // disableOptions: boolean = false;
  // disPlayReset: boolean = true;

  constructor(private _formBuilder: FormBuilder,
    private clientService: ClientService,
    private projectService: ProjectService,
    private schedulerService: SchedulerService,
    private npService: NursePractitionerService,
    private _localStorage: LocalStorageService,
    private _notificationService: NotificationService,
    public dialogRef: MatDialogRef<AssignnpModalComponent>,
    @Inject(MAT_DIALOG_DATA) public assignedNP: NursePractitioner) { }

  ngOnInit() {
    this.getClientList();
    this.newNP = []
    this.projects = [];
    this.getProjectsByClients(this.assignedNP.clientIds);
    this.loadProjects(this.assignedNP.projectIds);
   
    //alert(this.assignedNP.isAssigned);
    //this.assignedNP.isAssigned = false;
    //this.isAssigned = this.assignedNP.isAssigned;
    //if (this.assignedNP.isAssigned) {
      // this.disableOptions = true;
      // this.disPlayReset = false;
     // this.newNP.push(this.assignedNP)
      //this.selectedClient.push(...this.assignedNP.clientId+'');
      //alert(this.assignedNP.clientIds);
      //this.selectedProject.push(...this.assignedNP.projectId+'');
      //this.getNPs(this.assignedNP.projectIds);
      this._assignForm = this._formBuilder.group({
        clientIds: new FormControl({ value: this.assignedNP.clientIds, disabled: false }),
        projectIds: new FormControl({ value: this.assignedNP.projectIds, disabled: false }),
      });
    //}
    // else{
    //   // this.disableOptions = false;
    //   // this.disPlayReset = true;
    //   this.newNP.push(this.assignedNP)
    //   this._assignForm = this._formBuilder.group({
    //     clientIds: new FormControl({ value: this.selectedClient, disabled: false }),
    //     projectIds: new FormControl(this.selectedProject),
    //   });
    // }
  }

  getClientList() {
    this.clientService.getClients().subscribe(result => {
      if (!result) {
        return;
      }
      this.clients = result.clients;
      this._assignForm.get('clientIds').patchValue(this.assignedNP.clientIds)
      console.log("Client Name: " + this.clients[0].clientName);
    }, error => console.log(error));
  }

  getProjectsByClient({ value }) {
    //alert(value);
    this.projects = [];
    this.getProjectsByClients(value);
  }

  getProjectsByClients(value: number[]) {
      //alert(value);
      this.projectService.getProjectsByClientIds(value)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this.projects = result.projects;
        //this.selectedProject = this.assignedNP.projectId+'';
        console.log("projects: " + this.projects);
        let newProjectIds = [];
        this.projects.filter(p => {
          if(this._assignForm.get('projectIds').value.includes(p.projectId)){
            newProjectIds.push(p.projectId);
          }
        })
        this._assignForm.get('projectIds').patchValue(newProjectIds)
      }, error => console.log(error));
  }

  getNPsByProject({ value }) {
    //alert(value);
    this.getNPs(value);
    //this.loadProjects(value);
  }

  getNPs(value: string[]) {
    //alert(value);
    this.npService.getNPByProjectId(value)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this.assignedNps = result.nursePractitioners;
        //alert(this.assignedSchedulers);
        //console.log("projects: " + this.projects);
      }, error => console.log(error));
  }

  getNPByProject({ value }) {
    //alert(value);
    this.loadProjects(value);
    //this.getBatches(value);
  }

  loadProjects(value: number[]) {
    //alert(value);
    this.projectService.getProjectList(value)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
       // alert(result.projects);
        this.selectedProjects = result.projects;
        //this.selectedProjects.push(this.project);
        console.log("selectedProjects loaded: " + this.selectedProjects);
      }, error => console.log(error));
  }

  assign() {
    this.assignNursePractitionerRequest = this._assignForm.value;
    // this.newNP.filter(item => {
    //   item.isAssigned = true;
    // })
    //alert(this.assignNursePractitionerRequest.projectIds +'='+ this.assignNursePractitionerRequest.clientIds);
    this.assignNursePractitionerRequest.updatedBy = this._localStorage.retrieve('profile').displayName;
    this.assignNursePractitionerRequest.nursePractitionerId = this.assignedNP.nursePractitionerId;
    this.npService.assignNPs(this.assignNursePractitionerRequest)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this._notificationService.success('Assigned successfully');
        this.dialogRef.close(this._assignForm.value);
      }, error => console.log(error));
  }

  // deassign() {
  //   this.assignNursePractitionerRequest = this._assignForm.value;
  //   // this.newNP.filter(item => {
  //   //   this.assignNursePractitionerRequest.isAssigned = false;
  //   //   //this.assignNursePractitionerRequest.nursePractitionerId = item.nursePractitionerId;
  //   // })
  //   this.assignNursePractitionerRequest.updatedBy = this._localStorage.retrieve('profile').displayName;
  //   this.assignNursePractitionerRequest.nursePractitionerId = this.assignedNP.nursePractitionerId;
  //   this.npService.assignNPs(this.assignNursePractitionerRequest)
  //   .subscribe(result => {
  //     if (!result) {
  //       return;
  //     }
  //     console.log(result);
  //     this._notificationService.success('Deassigned successfully');
  //     this.dialogRef.close(this._assignForm.value);
  //   }, error => console.log(error));
  // }

  // panelSelected(panelOpen: boolean){
  //   //alert();
  //   if (!panelOpen) {
  //     this.disableOptions = true;
  //   }
  // }

  // changeResetButton(){
  //   this.disableOptions = false;
  //   this._assignForm.get('clientIds').setValue([]);
  //   this._assignForm.get('projectIds').setValue([]);
  //   this.assignedNps = [];
  // }
}
